// extracted by mini-css-extract-plugin
export default {"container":"BBPd3","extraMarginTop":"tDzCK","badgeContainer":"mt2Fi","badge":"uUSvP","date":"GUvFK","time":"DP31F","separator":"+gaI9"};